import { useEffect, useState } from 'react'
import { scrapeAITools } from '../lib/scraper'
import { Tool } from '../types/database'

// Generate stable ID from tool name
function generateStableId(name: string): string {
  return `scraped-${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')}`
}

export function useScrapedTools() {
  const [scrapedTools, setScrapedTools] = useState<Tool[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchScrapedTools()
  }, [])

  async function fetchScrapedTools() {
    try {
      setLoading(true)
      setError(null)

      const tools = await scrapeAITools()

      // Convert to Tool format with stable IDs based on tool name
      const toolsWithMetadata: Tool[] = tools.map((tool) => ({
        ...tool,
        id: generateStableId(tool.name),
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }))

      setScrapedTools(toolsWithMetadata)
    } catch (err: any) {
      console.error('Error fetching scraped tools:', err)
      setError(err.message)
      setScrapedTools([])
    } finally {
      setLoading(false)
    }
  }

  return {
    scrapedTools,
    loading,
    error,
    refresh: fetchScrapedTools,
  }
}
